import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const PHOTO = "https://storage.readdy-site.link/project_files/1dd47190-5ea2-431c-a9ac-432354462ac6/e32b9269-066f-449e-8013-759c01048f22_ec7d1e9dd74ec5af65c12cb2fe448cd4756c5390.png?v=050081879659d0caf3c5e11302fdc1dc";

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative min-h-screen bg-white flex items-center overflow-hidden pt-16">
      {/* Background decorative shapes */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 right-0 w-[600px] h-[600px] rounded-full bg-[#00D873]/5 translate-x-1/3" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-[#F2F4F6] -translate-x-1/3 translate-y-1/3" />
      </div>

      <div className="max-w-6xl mx-auto px-6 w-full py-20 lg:py-28">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-20">

          {/* Text Content */}
          <div className="flex-1 text-center lg:text-left">
            {/* Badge */}
            <div
              className={`inline-flex items-center gap-2 bg-[#F2F4F6] px-4 py-2 rounded-full mb-8 transition-all duration-700 ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
              }`}
            >
              <span className="w-2 h-2 bg-[#00D873] rounded-full animate-pulse" />
              <span className="text-sm font-medium text-[#191F28]">이미 8,400명의 세오님들이 AI로 시간을 벌고 있어요</span>
            </div>

            {/* Main Headline */}
            <h1
              className={`font-black text-[#191F28] mb-8 transition-all duration-700 delay-100 ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
              }`}
            >
              <span className="block text-4xl lg:text-5xl xl:text-6xl leading-[1.15] mb-2 text-[#191F28]/70">남들은 엑셀 할 때,</span>
              <span className="block text-5xl lg:text-6xl xl:text-7xl leading-[1.1]">
                우리는 AI로{" "}
                <span className="relative inline-block">
                  성공하세오.
                  <span className="absolute bottom-1 left-0 right-0 h-3 lg:h-4 bg-[#00D873]/20 rounded-full -z-10" />
                </span>
              </span>
            </h1>

            {/* Sub */}
            <p
              className={`text-lg lg:text-xl text-[#191F28]/60 mb-10 leading-[1.9] max-w-lg transition-all duration-700 delay-200 ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
              }`}
            >
              하루 2시간, 1도 부담 없는 AI 챌린지로
              <br />
              퇴근은 당기고 통장은 채우세요.
            </p>

            {/* CTA Buttons */}
            <div
              className={`flex flex-col sm:flex-row items-center lg:items-start gap-4 transition-all duration-700 delay-300 ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
              }`}
            >
              <Link
                to="/dashboard"
                className="bg-[#00D873] text-white font-bold text-lg px-10 py-4 rounded-full hover:opacity-90 transition-all duration-200 hover:-translate-y-1 whitespace-nowrap cursor-pointer"
              >
                10초 만에 세오 되기 →
              </Link>
              <Link
                to="/community"
                className="flex items-center gap-2 text-[#191F28] font-medium text-base hover:text-[#00D873] transition-colors cursor-pointer whitespace-nowrap"
              >
                <span>수익 인증 구경하기</span>
                <i className="ri-arrow-right-line" />
              </Link>
            </div>

            {/* Stats */}
            <div
              className={`mt-14 flex flex-wrap justify-center lg:justify-start gap-10 transition-all duration-700 delay-500 ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
              }`}
            >
              {[
                { value: "월 평균 18h", label: "절약된 업무 시간" },
                { value: "2,100+", label: "수익화 성공 세오님" },
                { value: "340+", label: "수익형 AI 챌린지" },
              ].map((s) => (
                <div key={s.label} className="text-center lg:text-left">
                  <div className="text-2xl lg:text-3xl font-black text-[#191F28]">{s.value}</div>
                  <div className="text-sm text-[#191F28]/50 mt-1">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Real Photo */}
          <div
            className={`flex-1 relative transition-all duration-1000 delay-400 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            <div className="relative w-full max-w-[460px] mx-auto pb-6 sm:pb-8">
              {/* Photo */}
              <div className="relative z-10 rounded-3xl overflow-hidden" style={{ aspectRatio: "3/4" }}>
                <img
                  src={PHOTO}
                  alt="GrowSeo 실제 사용 현장"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute bottom-0 left-0 right-0 h-1/4 bg-gradient-to-t from-black/15 to-transparent" />
              </div>

              {/* Floating Card — 연속 달성 */}
              <div
                className="absolute left-0 sm:-left-8 top-14 bg-white rounded-2xl px-4 py-3 z-20 border border-[#F2F4F6]"
                style={{ boxShadow: "0 6px 24px rgba(0,0,0,0.09)" }}
              >
                <div className="flex items-center gap-2">
                  <span className="text-xl">🔥</span>
                  <div>
                    <div className="text-xs text-[#191F28]/50">연속 달성</div>
                    <div className="text-sm font-bold text-[#191F28]">14일 째!</div>
                  </div>
                </div>
              </div>

              {/* Floating Card — Grow Points */}
              <div
                className="absolute right-0 sm:-right-7 top-1/3 bg-[#191F28] rounded-2xl px-4 py-3 z-20"
                style={{ boxShadow: "0 6px 24px rgba(0,0,0,0.18)" }}
              >
                <div className="flex items-center gap-2">
                  <span className="text-xl">🌱</span>
                  <div>
                    <div className="text-xs text-white/50">Grow Points</div>
                    <div className="text-sm font-bold text-[#00D873]">+150P 적립!</div>
                  </div>
                </div>
              </div>

              {/* Floating Card — 챌린지 완료 */}
              <div
                className="absolute bottom-0 sm:-bottom-4 left-1/4 bg-[#00D873] rounded-2xl px-4 py-3 z-20"
                style={{ boxShadow: "0 6px 24px rgba(0,216,115,0.35)" }}
              >
                <div className="flex items-center gap-2">
                  <span className="text-xl">✅</span>
                  <div className="text-sm font-bold text-white">챌린지 완료!</div>
                </div>
              </div>

              {/* Decorative glow */}
              <div className="absolute -inset-3 bg-gradient-to-br from-[#00D873]/12 via-transparent to-transparent rounded-3xl -z-10" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
